import {dataLayer} from 'shared'

export const EETeaserClicktracking = () =>
  document.querySelectorAll('[data-ee-promo-attributes]').forEach(teaser => {
    teaser.addEventListener('click', () => {
      dataLayer.push({
        'event': 'eeTeaserClick',
        'ecommerce': {
          'promoClick': {
            'promotions': [JSON.parse(teaser.dataset.eePromoAttributes)]
          }
        }
      })
    })
  })
